module.exports = __webpack_public_path__ + "img/4H.cb60aa7c.svg";